export enum CategoryActions {
    fetchCategories = 'FETCH_CATEGORIES',
    createCategory = 'CREATE_CATEGORY',
    deleteCategory = 'DELETE_CATEGORY',
    editCategory = 'EDIT_CATEGORY',
    queryCategories = 'QUERY_CATEGORIES',
}
